import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left text-zinc-200 bg-zinc-700" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { class: "w-0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  class: /*#__PURE__*/_normalizeClass(['text-right', 'w-5'])
}, null, -1)

import { Attribute } from '../types/Attribute';
import AppStatsHeadingTitle from './AppStatsHeadingTitle.vue';
import { Sort } from '../types/Sort';


export default /*#__PURE__*/_defineComponent({
  props: {
    columns: null,
    sort: null,
    cellClass: null
  },
  emits: ["changeSort"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeSort', sort: Sort): void
}), expose: any, slots: any, attrs: any }) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("th", {
      class: _normalizeClass(["w-48", [...__props.cellClass]])
    }, [
      _createVNode(AppStatsHeadingTitle, {
        sorted: __props.sort.type === 'category' ? __props.sort.direction : false,
        title: "Тип техники",
        onToggleSort: _cache[0] || (_cache[0] = ($event: any) => (emit('changeSort', {type: 'category', direction: $event})))
      }, null, 8, ["sorted"])
    ], 2),
    _createElementVNode("th", {
      class: _normalizeClass(["w-36", [...__props.cellClass]])
    }, [
      _createVNode(AppStatsHeadingTitle, {
        sorted: __props.sort.type === 'brand' ? __props.sort.direction : false,
        title: "Бренд",
        onToggleSort: _cache[1] || (_cache[1] = ($event: any) => (emit('changeSort', {type: 'brand', direction: $event})))
      }, null, 8, ["sorted"])
    ], 2),
    _createElementVNode("th", {
      class: _normalizeClass(["w-auto", [...__props.cellClass]])
    }, [
      _createVNode(AppStatsHeadingTitle, {
        sorted: __props.sort.type === 'title' ? __props.sort.direction : false,
        title: "Модель",
        onToggleSort: _cache[2] || (_cache[2] = ($event: any) => (emit('changeSort', {type: 'title', direction: $event})))
      }, null, 8, ["sorted"])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (attribute, filterName) => {
      return (_openBlock(), _createElementBlock("th", {
        key: filterName,
        class: _normalizeClass(["w-auto", [...__props.cellClass]])
      }, [
        _createVNode(AppStatsHeadingTitle, {
          sorted: __props.sort.type === 'attribute' && __props.sort.attributeId === attribute.id ? __props.sort.direction : false,
          title: attribute.title,
          description: attribute.description,
          onToggleSort: ($event: any) => (emit('changeSort', {type: 'attribute', attributeId: attribute.id, direction: $event}))
        }, null, 8, ["sorted", "title", "description", "onToggleSort"])
      ], 2))
    }), 128))
  ]))
}
}

})